export default __webpack_public_path__ + "static/media/bankVerificationhelpMobileHighlight@2x.ff89725b.png";